import { BrowserType, DeepLink, PlatformType } from "./deeplink";

export type IAndroid = {
    fallbackWebUrl: string;
    appId: string;
    appName: string;
};

export default class Android implements DeepLink {
    fallbackWebUrl?: string;
    storeUrl: string;
    appId?: string;
    appName?: string;
    protocol: string;
    type: PlatformType;
    _browser: BrowserType;
    constructor(props?: IAndroid) {
        this.type = 'android';
        this.protocol = 'hiseas://';
        this.appName = props?.appName;
        this.storeUrl = 'market://details?id=';
        this.fallbackWebUrl = props?.fallbackWebUrl;
        this.appId = props?.appId;
        this._browser = 'default browser';
    }

    public get browser() {
        return this._browser;
    }

    open(url: string) {
        if (url.startsWith(this.protocol)) {
            this.openUrl(url);
        } else {
            this.openUrl(`${this.protocol}${url}`);
        }
    }
    getStoreURL(): string {
        const baseurl = this.storeUrl;
        const appName = this.appName;
        const id = this.appId;
        return (id && appName) ? (baseurl + appName + "/id" + id + "?mt=8") : '';
    }
    openDapp(url: string) {
        if (url.startsWith("browser/url=")) {
            this.open(url);
        } else {
            this.open(`browser/url=${url}`);
        }
    }
    openUrl(url: string) {
        const a = document.createElement("a");
        a.href = url;
        a.target = "_self";
        document.body.appendChild(a);
        a.click();
        a.remove();
    }
}
